export const verificarCedibilidad = ({
  evaluacionCedibilidad = null,
  clienteRut = [], // ahora ES LISTA
  nroDocumento,
}) => {
  //Lo datos se validan con textract
  const errores = [];

  if (evaluacionCedibilidad) {
    // 🔹 Normalizador de RUT
    const normalizarRut = (rut) =>
      rut?.toLowerCase().replaceAll(".", "").replaceAll("-", "");

    // 🔹 ¿Existe algún RUT que coincida?
    // console.log(evaluacionCedibilidad.extRut);
    // console.log(clienteRut);
    const existeRutCliente = evaluacionCedibilidad.extRut.some((rutFactura) =>
      clienteRut.some(
        (rutLista) => normalizarRut(rutFactura) === normalizarRut(rutLista)
      )
    );

    const existeTerminoTipoDoc = evaluacionCedibilidad.extTerminoDoc;

    const existeNumeroDocumento = evaluacionCedibilidad.extNumDoc.some(
      (x) => x == nroDocumento
    );

    const existeTerminoCedible = evaluacionCedibilidad.extCedible;

    // ❗ Validación correcta: RUT de la factura vs lista
    // if (!existeRutCliente) {
    //   errores.push(
    //     "El RUT de la factura no coincide con ninguno de los receptores asociados."
    //   );
    // }

    // Tipo Documento
    // if (!existeTerminoTipoDoc) {
    //   errores.push(
    //     "El tipo de Documento no coincide con lo especificado en la factura."
    //   );
    // }

    // // Número Documento
    // console.log(evaluacionCedibilidad.extNumDoc);
    // if (!existeNumeroDocumento) {
    //   errores.push(
    //     "El número de la factura no coincide con lo especificado en el campo Nro. Documento."
    //   );
    // }

    // Cedible
    // if (!existeTerminoCedible) {
    //   errores.push("La factura debe contener el término Cedible.");
    // }

    return errores;
  }

  return errores;
};
